<nz-card class="flow-card" nzTitle="Processing Fee">
  <p class="flow-card__subtitle">Select processing fee options and preferences before finalizing the order.</p>

  <form [formGroup]="pFeeForm" class="flow-form">
    <div class="form-field">
      <label class="form-label">Processing Fee</label>
      <nz-select
        nzPlaceHolder="Select amount"
        formControlName="processingFee"
      >
        <nz-option
          *ngFor="let fee of processingFees"
          [nzValue]="fee.value"
          [nzLabel]="fee.title"
        ></nz-option>
      </nz-select>
    </div>

    <div
      class="form-field"
      *ngIf="
        pFeeForm.get('processingFee')?.value &&
        pFeeForm.get('processingFee')?.value !== '$0.00'
      "
    >
      <label class="form-label">
        Fee Date
        <span class="form-label__required">
          *
          <span
            *ngIf="
              pFeeForm.get('processingFeeDate')?.touched &&
              pFeeForm.get('processingFeeDate')?.errors?.['afterOrEqualToday']
            "
          >
            Must be today or later
          </span>
        </span>
      </label>
      <nz-date-picker
        formControlName="processingFeeDate"
        [nzStatus]="
          pFeeForm.get('processingFeeDate')?.touched &&
          pFeeForm.get('processingFeeDate')?.invalid
            ? 'error'
            : ''
        "
      ></nz-date-picker>
    </div>

    <div class="form-field">
      <label class="form-label">Promo Code</label>
      <nz-select
        nzPlaceHolder="Promo"
        [nzDisabled]="fullData.prequal"
        formControlName="promoCode"
      >
        <nz-option
          *ngFor="let offer of offers"
          [nzValue]="offer.value"
          [nzLabel]="offer.display_name"
        ></nz-option>
      </nz-select>
    </div>

    <div class="form-grid">
      <div class="form-field">
        <label class="form-label">Security Pin <span class="form-label__required">*</span></label>
        <input
          nz-input
          placeholder="1234"
          type="tel"
          maxlength="4"
          formControlName="pin"
        />
      </div>

      <div class="form-field">
        <label class="form-label">Pin Hint <span class="form-label__required">*</span></label>
        <input
          nz-input
          placeholder="Hint for pin"
          maxlength="30"
          formControlName="pinHint"
        />
      </div>
    </div>

    <div class="preferences-group">
      <label nz-checkbox formControlName="autopay">AutoPay Enrollment</label>
      <label nz-checkbox formControlName="paperless">Paperless Billing</label>
    </div>

    <div class="flow-actions flow-actions--trailing">
      <button
        nz-button
        nzType="primary"
        nzBlock
        [disabled]="pFeeForm.invalid"
        (click)="submitForm()"
        [nzLoading]="submitting"
      >
        Next Step
      </button>
    </div>
  </form>
</nz-card>
